module.exports = __webpack_public_path__ + "img/menu-icon.a450cc10.svg";